import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReporteService } from '@app/core/service/reporte.service';

@Component({
  selector: 'app-r-pago-proveedores',
  templateUrl: './r-pago-proveedores.component.html',
  styleUrls: ['./r-pago-proveedores.component.css']
})
export class RPagoProveedoresComponent implements OnInit {
  pagos: any;
  fecha_inicio = new FormControl('', []);
  fecha_fin = new FormControl('', []);
  nro_comprobante: any='';
  total: any

  constructor(
    private reporteService: ReporteService
  ) { }

  ngOnInit() {
    this.lista('','','');
    this.fecha_inicio.valueChanges.subscribe(data => {
      this.lista(this.nro_comprobante,data, this.fecha_fin.value);
    });
    this.fecha_fin.valueChanges.subscribe(data => {
      this.lista(this.nro_comprobante,this.fecha_inicio.value, data);
    });
  }
  lista(nro_comprobante:any,fecha_inicio:any,fecha_fin:any) {
    this.reporteService.reportePagoProveedor(nro_comprobante,fecha_inicio,fecha_fin).subscribe((data:any)=>{
      this.pagos = data;
      data.forEach((element:any) => {
        this.total = element.monto;
      });
    })
  }

  buscarPagos(nro_comprobante: any) {
    this.nro_comprobante = nro_comprobante
    this.lista(nro_comprobante,'','');
  }

}
